import React, { useCallback } from 'react';

import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';

interface Props {
  isModalVisible: boolean;
  hideModal: () => void;
  saveOperation: () => void;
}

function ExperienceOfferVendorUpdatedWarningModal({ isModalVisible, hideModal, saveOperation }: Props) {
  const saveAndCloseModal = useCallback(() => {
    saveOperation();
    hideModal();
  }, [hideModal, saveOperation]);

  return (
    <Dialog open={isModalVisible} onClose={hideModal}>
      <DialogTitle>Warning: Vendor information has been updated</DialogTitle>
      <DialogContent>
        <Stack spacing={2}>
          <Typography variant="subtitle2">
            The vendor information has changed. Proceeding with this action will update the vendor information for all
            offers that have the same vendor. If you wish to continue, please confirm and save. If not, select 'Cancel'.
          </Typography>

          <Grid container spacing={2} alignItems="center">
            <Button type="submit" color="primary" variant="contained" onClick={saveAndCloseModal}>
              Confirm and Save
            </Button>
          </Grid>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Stack justifyContent="end">
          <Button variant="contained" color="warning" onClick={hideModal}>
            Cancel
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
}

export default ExperienceOfferVendorUpdatedWarningModal;
